import axios from 'axios';
import qs from 'qs';
import BaseService from 'packages/Base/services/BaseService';

export default class PracticeConversationService extends BaseService {

  constructor() {
    super('/lawyer-one/practice-conversations');
    this.api_url = process.env.REACT_APP_API_URL + '/lawyer-one/practice-conversations';
  }
}